/**
 * @module setting
 */

const state = {
  companyCd: null,
  storeCd: null,
  userName: null,
  password: null,
  formatId: 1,
  halfPriceFormatId: 4,
  printerURL: "http://localhost:8080",
}

const getters = {
}

const mutations = {
  saveSetting(state, payload) {
    state.companyCd = payload.companyCd
    state.storeCd = payload.storeCd
    state.userName = payload.userName
    state.password = payload.password
    state.formatId = payload.formatId
    state.halfPriceFormatId = payload.halfPriceFormatId
    state.printerURL = payload.printerURL
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
